<template>
  <li
    class="navigation-sp-item"
    v-on:click="isOpened = !isOpened"
    :class="{ 'is-open': isOpened }"
  >
    <div class="navigation-sp-item-inner">会社情報</div>

    <ul class="navigation-sp-child" v-show="isOpened">
      <li class="navigation-sp-item" v-for="menu in menus" :key="menu.path">
        <a class="navigation-sp-item-inner" :href="menu.path">
          {{ menu.name }}
        </a>
      </li>
    </ul>
  </li>
</template>

<script>
import Menus from "@/mixins/aboutMenus.js";

export default {
  mixins: [Menus],
  data: function () {
    return {
      isOpened: false,
    };
  },
  computed: {
    menus() {
      return this.aboutTop.concat(this.aboutMenus);
    },
  },
};
</script>

<style scoped>
.navigation-sp-child {
  display: block;
}
</style>
